import { resolveCurrencySymbol } from './resolve-currency-symbol.js';
/**
 * Formats a minor-units amount as an inline rate string with a unit suffix.
 *
 * Drops trailing `.00` on whole-unit values so line-item descriptions read
 * cleanly ("R1,500/hr" not "R1,500.00/hr") while preserving cents when
 * non-zero ("R1,500.50/hr"). Currency defaults to ZAR.
 *
 * Used by invoice line-item descriptions on the PDF, the read-only invoice
 * view, and the email line-item sub-line.
 *
 * Example: formatInlineRate(150000, 'hr', 'ZAR') => 'R1,500/hr'
 *          formatInlineRate(150050, 'hr')        => 'R1,500.50/hr'
 *          formatInlineRate(800, 'km')           => 'R8/km'
 */
export function formatInlineRate(minorUnits, unitSuffix, currency = 'ZAR') {
    const symbol = resolveCurrencySymbol(currency);
    const hasCents = minorUnits % 100 !== 0;
    const number = (minorUnits / 100).toLocaleString('en-GB', {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2,
    });
    return `${symbol}${number}/${unitSuffix}`;
}
